import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CaseStudyCard } from './CaseStudyCard';
import { caseStudies } from '../../data/caseStudies';

const industries = ['All', 'Manufacturing', 'Education', 'Non-Profit'];

export const CaseStudiesGrid: React.FC = () => {
  const [selectedIndustry, setSelectedIndustry] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredCaseStudies = useMemo(() => {
    return caseStudies.filter(study => {
      const matchesIndustry = selectedIndustry === 'All' || study.industry === selectedIndustry;
      const matchesSearch = study.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          study.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          study.technologies.some(tech => tech.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesIndustry && matchesSearch;
    });
  }, [selectedIndustry, searchQuery]);

  return (
    <section className="section">
      <div className="container">
        {/* Filters */}
        <div className="mb-8 space-y-4">
          <div className="flex flex-wrap gap-2">
            {industries.map((industry) => (
              <button
                key={industry}
                onClick={() => setSelectedIndustry(industry)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  selectedIndustry === industry
                    ? 'bg-primary-light dark:bg-primary-dark text-white'
                    : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'
                }`}
              >
                {industry}
              </button>
            ))}
          </div>

          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by title, description, or technology..."
              className="w-full px-4 py-2 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark"
            />
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <AnimatePresence mode="wait">
            {filteredCaseStudies.map((study, index) => (
              <CaseStudyCard
                key={study.id}
                caseStudy={study}
                index={index}
              />
            ))}
          </AnimatePresence>
        </div>

        {filteredCaseStudies.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 dark:text-gray-400">
              No case studies found matching your criteria.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
